
import React, {FC} from 'react';
import classNames from 'classnames';
import {useContextConfig} from 'pages/pricing-packages/components/context';

import * as styles from './styles.module.scss';

export type HeadingProps = {
	children?: React.ReactNode,
	selected?: boolean,
	onSelect?: () => void,
};

const Heading: FC<HeadingProps> = ({children, selected, onSelect}) => {
	const config = useContextConfig();
	return (
		<div onClick={onSelect} className={classNames({
			[styles.heading]: true,
			[styles.selected]: selected,
			[styles.modal]: config.modal,
		})}>
			<div>{children}</div>
			{selected && (
				<div className={classNames({
					[styles.highlight]: true,
					[styles.modal]: config.modal,
				})} />
			)}
		</div>
	);
};

export default Heading;
